import styled from 'styled-components';

export const LlegendaFooterWrapper = styled.div`
  align-self: flex-start;
  margin-bottom: 10px;
  margin-top: 5px;
`;

export const CleanLlegenda = styled.button`
  border-style: none;
  background: none;
`;

export const ExpandButton = styled.button`
  border-style: none;
  background: none;
`;

export const ShrinkButton = styled.button`
  border-style: none;
  background: none;
`;

export const EyeMasterButton = styled.button`
  border-style: none;
  background: none;
`;
